if (!customElements.get('size-guide-variant-image')) {
  customElements.define(
    'size-guide-variant-image',
    class SizeGuideVariantImage extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        if (typeof subscribe !== 'function') return;

        // Dawn re-fetches the section on every variant change and passes the parsed
        // document in the event. Swap in the freshly rendered variant image — no
        // extra request, and all markup stays server-rendered.
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data?.sectionId !== this.sectionId) return;
          const updatedImage = event.data.html?.getElementById(this.id);
          if (updatedImage) this.innerHTML = updatedImage.innerHTML;
        });
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }
    }
  );
}
